import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CustomButton from './CustomButton';
import './PerguntasFrequentesParceirosSection.css';
import { useNavigate } from 'react-router-dom';

const PerguntasFrequentesParceirosSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const navigate = useNavigate()

  const faqs = [
    {
      question: 'Preciso pagar algo para entrar?',
      answer: 'Não há mensalidade nem taxas ocultas. O custo é apenas o valor do repasse que você escolhe. Você só paga quando recebe um cliente através da plataforma.'
    },
    {
      question: 'Preciso trocar meu sistema?',
      answer: 'Não! A plataforma se integra facilmente com seu sistema atual. Você pode usar apenas as funcionalidades que precisar, como validação via QR Code e relatórios básicos.'
    },
    {
      question: 'Dá trabalho treinar o time?',
      answer: 'Não! A plataforma é simples e intuitiva. Seu time aprende rapidamente a usar as funcionalidades principais, como validação via QR Code e consulta de agendamentos.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="perguntas-frequentes-parceiros-section">
      <div className="perguntas-frequentes-parceiros-content">
        <h2 className="perguntas-frequentes-parceiros-title">Perguntas Frequentes</h2>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? 'open' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <ExpandMoreIcon
                  className={`faq-icon ${openIndex === index ? 'open' : ''}`}
                />
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="perguntas-frequentes-parceiros-button">
          <CustomButton
            variant="contained"
            sx={{
              backgroundColor: '#FF914D',
              color: '#FFFFFF',
              padding: '14px 32px',
              fontSize: '16px',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#e67e3d',
              },
            }}
            onClick={() => navigate('/cadastro-parceiro')}
          >
            Seja parceiro
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default PerguntasFrequentesParceirosSection;

